// const DEVELOPMENT_LINK = 'http://13ovp3jymj.laravel-sail.site:8080/api'
const DEVELOPMENT_LINK = 'http://localhost:8000/api'
// https://fn5jfxjtxl.laravel-sail.site/
const PRODUCTION_LINK = 'https://originalplafonpvc.com/api'

export const BASE_API_URL = process.env.NODE_ENV === 'development' ? DEVELOPMENT_LINK : PRODUCTION_LINK